











import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class PriceChart extends Vue {
  @Prop() prices;

  @Prop() expand;

  get meta() {
    const columns = ["Index", "Price"];
    const rows = this.prices.map((p, i) => ({
      [columns[0]]: i,
      [columns[1]]: p
    }));
    // const last = rows[rows.length - 1] || {};
    return {
      height: this.expand ? "100%" : "40px",
      chartData: {
        columns,
        rows
      },
      colors: ["#169CFE"],
      extend: {
        grid: [{ top: 0, bottom: 0, left: 0, height: "100%", width: "100%" }],
        axisPointer: {
          lineStyle: {
            color: "#CCCCCC"
          }
        },
        xAxis: {
          show: false,
          scale: false,
          axisLabel: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          show: false,
          scale: true,
          axisLabel: {
            show: false
          },
          max: "dataMax",
          min: "dataMin"
        },
        tooltip: {
          show: false,
          textStyle: {
            fontSize: 13
          }
        },
        legend: {
          show: false
        },
        series: {
          name: "price",
          type: "line",
          animation: false,
          showSymbol: false,
          silent: true,
          smooth: 0.2,
          clip: false,
          sampling: "average",
          lineStyle: {
            color: "#169CFE",
            width: 1
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(22, 156, 254, 0.14)" // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(22, 156, 254, 0)" // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            }
          }
        }
        // markLine: {
        //   symbol: "none",
        //   data: [
        //     {
        //       name: "current",
        //       // 支持 'average', 'min', 'max'
        //       yAxis: last[columns[1]],
        //       lineStyle: {
        //         color: "#CCCCCC"
        //       },
        //       label: {
        //         show: this.expand,
        //         position: "insideEndTop"
        //       }
        //     }
        //   ]
        // }
      }
    };
  }
}
export default PriceChart;
